module.exports = __webpack_public_path__ + "static/media/pchess.aaa440be.gif";